import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';
import mutations from './mutations';
import { getters } from './getters';
import actions from './actions';
import { fight } from './fight/index';
import { world } from './world/index';
import { group } from './group/index';
import { Client } from '@bugsnag/browser/dist/types/bugsnag-core';

Vue.use(Vuex);

declare var process: {
  env: {
    VUE_APP_VERSION: string,
    NODE_ENV: string,
    VUE_APP_FIREBASE_TARGET: string,
    BASE_URL: string,
  },
};

const store: StoreOptions<RootState> = {
  state: {
    user: null,
    settings: {},
    groups: [],
    world: 'vjorngard',
    currentGroup: 'yJpuptoj376oErL0i5a8',
    currentGroupData: null,
    worldData: {
      locations: [],
      misc: [],
    },
    userData: null,
    messages: [],
    presets: [],
    isSaving: false,
    lastSave: 0,
    backgroundImage: 'Battle.jpg',
    backgroundOpacity: 50,
    version: process.env.VUE_APP_VERSION,
    bugsnagClient: {
      // tslint:disable-next-line: no-empty
      notify: () => {},
      // tslint:disable-next-line: no-empty
      leaveBreadcrumb: () => {},
      user: null,
    } as unknown as Client,
  },
  mutations,
  getters,
  actions,
  modules: {
    fight,
    world,
    group,
  },
};

export default new Vuex.Store<RootState>(store);
